export default __webpack_public_path__ + "static/media/default.b2017d841af4119ad4dca492c42b08f9.png";